import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';

export const AuthGuard: CanMatchFn = (route: Route, segments: UrlSegment[]) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const isAuthenticated = authService.authStatus() === 'authenticated';

  if (isAuthenticated) return true;

  return router.createUrlTree(['/auth/login']);
};

export const GuestGuard: CanMatchFn = (route: Route, segments: UrlSegment[]) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (authService.authStatus() === 'authenticated') {
    return router.createUrlTree(['/veflo-vault/chat']);
  }

  return true;
};
